module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"document":"Dokument:","document_hint":"Bitte wählen Sie ein Dokument mit der Erweiterung `{0}` bis zu 5 MB."},"en":{"document":"Document:","document_hint":"Please select document with `{0}` extension up to 5 MB."}}')
  delete Component.options._Ctor
}
